import Controller from '@ember/controller';
import ENV from 'donor-elf-web/config/environment';

export default class AdminUsersShowActivationLinkController extends Controller {
  get activationLink() {
    return `${ENV.apiUrl}/users/invitation?code=${this.model.activationCode}`;
  }
}
